import React from "react";

import { useStrings } from "../../../../localization/localizationHelpers";

import * as styles from "./PartnerProgramsIntro.module.css";

export const PartnerProgramsIntro = () => {
  const [title, description] = useStrings(
    "landingProgramsIntroTitle",
    "landingProgramsIntroDescription"
  );

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </section>
  );
};
